module.exports = __webpack_public_path__ + "static/media/famila-logo.ad7bfe93.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/famila-logo.png
// module id = 732
// module chunks = 0